import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'    
import {useSelector, useDispatch} from 'react-redux'         
import EntryForm from '../components/EntryForm'   
import {getEntries, reset} from '../features/entries/entrySlice'
import Spinner from '../components/Spinner'

function Dashboard() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {user} = useSelector((state) => state.auth) 
  const {entries, isError, message, isLoading} = useSelector((state) => state.entries)   
  
  useEffect(() => {
    if (isError) {
      console.log(message)
    }

    if (!user) {
      navigate('/login')    
    }

    dispatch(getEntries())

    return () => {
      dispatch(reset())
    }
   
  //}, [navigate, dispatch, user, entrys, isError, message, ])
}, [navigate, dispatch, user])

  if (isLoading) {
    return <Spinner/>     
  }

  // changed from <> to div, to add "styles":  style="background-color:gray;"
  return (
    <div>
      <section>
        {/* we have access to the user, as defined above ^^
        This syntax means: if user, show user.name. Pretty neat. */}

        {/* <h1>Welcome {user && user.name}</h1>     */}
        <h1>Welcome to Roman's County Jail</h1>
        <p className="logga">logged in as "{user && user.name}"</p>
      </section>
      <EntryForm/>
    </div>
  )
}

export default Dashboard

